import { render } from "./UpdateRole.vue?vue&type=template&id=7accd550"
import script from "./UpdateRole.vue?vue&type=script&lang=js"
export * from "./UpdateRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__